import { BORROWER_LAST_NAME_MIN_LENGTH } from 'utils/constants';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';

export const validateFirstName = (value: string, fieldName: string) => {
  const regex = /^[a-zA-Z]+$/;

  if (!regex.test(value)) {
    return `${fieldName} can only contain Latin letters`;
  }
};

export const validateLastName = (value: string, fieldName: string) => {
  if (value.trim().length < BORROWER_LAST_NAME_MIN_LENGTH) {
    return `${fieldName} cannot be less than 2 characters`;
  }

  // allow "a-z", "'", "-" and space
  const regex = /^[a-zA-Z\s'-]+$/;

  if (!regex.test(value)) {
    return `${LoanInformationVariables.LastName} can only contain Latin letters, apostrophes and hyphens`;
  }
};

export const validateCityField = (value: string, fieldName: string) => {
  // allow "a-z", space
  const regex = /^[a-zA-Z\s]+$/;

  if (!regex.test(value)) {
    return `${fieldName} can only contain Latin letters`;
  }
};

export const validateStreetField = (value: string, fieldName: string) => {
  // allow "a-z", space and digits
  const regex = /^[a-zA-Z\s\d]+$/;

  if (!regex.test(value)) {
    return `${fieldName} can only contain Latin letters and digits`;
  }
};
